import {
    Decimal,
} from 'decimal.js';

// Форматирует строковый numeric с бэкенда без перевода во float.
// Хвостовые нули убираются: "104.43000000" -> "104.43"
export default function formatDecimal(value: string | null): string {
    if (value === null) {
        return '-';
    }

    return new Decimal(value).toFixed();
}
